"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _react = _interopRequireWildcard(require("react"));
var _kebabCase = _interopRequireDefault(require("lodash/kebabCase"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _reactResponsive = _interopRequireDefault(require("react-responsive"));
var _commonCta = require("@mmc/common-cta");
var _commonMediaQuery = require("@mmc/common-media-query");
var _modal = _interopRequireDefault(require("./modal"));
var _checkbox = _interopRequireDefault(require("./checkbox"));
var _buttonPill = _interopRequireDefault(require("./button-pill"));
var _dropdown = _interopRequireDefault(require("./dropdown"));
var _locationFinder = _interopRequireDefault(require("./location-finder"));
var _offersV = require("../offers-v3.config");
var _offersV2 = require("../offers-v3.utils");
var _offersFilter = require("./offers-filter.utils");
var _offersFilter2 = _interopRequireDefault(require("./offers-filter.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var OffersFilter = /*#__PURE__*/function (_React$PureComponent) {
  function OffersFilter(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    _this.locationDropdownRef = /*#__PURE__*/(0, _react.createRef)();
    var _this$props = _this.props,
      data = _this$props.data,
      queryParams = _this$props.queryParams;
    _this.filters = (0, _offersFilter.normalizeFiltersFromGraphQL)(data);
    var selectedFilters = _this.getSelectedFilters(queryParams);
    _this.state = {
      isModalOpen: false,
      selectedFilters: selectedFilters,
      defaultFilters: selectedFilters,
      selectedFiltersErrors: {},
      totalSelectedFilters: (0, _offersFilter.getTotalSelectedFilters)(selectedFilters)
    };
    _this.prevSelectedFilters = selectedFilters;
    _this.toggleModal = _this.toggleModal.bind(_this);
    _this.restoreFilters = _this.restoreFilters.bind(_this);
    _this.cacheFilters = _this.cacheFilters.bind(_this);
    _this.handleOpenModal = _this.handleOpenModal.bind(_this);
    _this.handleApplyModal = _this.handleApplyModal.bind(_this);
    _this.handleCancelModal = _this.handleCancelModal.bind(_this);
    _this.handleLocationChange = _this.handleLocationChange.bind(_this);
    _this.propagateChange = _this.propagateChange.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2["default"])(OffersFilter, _React$PureComponent);
  OffersFilter.cookie = function cookie(key, value) {
    if (value === null) {
      _jsCookie["default"].remove(key);
    } else if (value !== undefined) {
      _jsCookie["default"].set(key, value);
    } else {
      return _jsCookie["default"].get(key);
    }
  };
  var _proto = OffersFilter.prototype;
  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;
    if (typeof window !== 'undefined') {
      var _this$state = this.state,
        defaultFilters = _this$state.defaultFilters,
        selectedFilters = _this$state.selectedFilters;
      window.onpopstate = function () {
        if (defaultFilters !== selectedFilters) {
          _this2.setState({
            selectedFilters: defaultFilters
          });
          _this2.toggleModal();
          _this2.propagateChange('vehicles');
        } else {
          window.history.back();
        }
      };
    }
  };
  _proto.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps) {
    var _this3 = this;
    var queryParams = this.props.queryParams;
    var prevParams = prevProps.queryParams;
    var normalizedQueryParams = (0, _offersFilter.normalizeQueryParams)(queryParams);
    var normalizedPrevParams = (0, _offersFilter.normalizeQueryParams)(prevParams);
    if (!(0, _isEqual2["default"])(normalizedQueryParams, normalizedPrevParams)) {
      var selectedFilters = this.getSelectedFilters(queryParams);
      this.setState({
        selectedFilters: selectedFilters
      }, function () {
        return _this3.propagateChange();
      });
    }
  };
  _proto.handleOpenModal = function handleOpenModal() {
    this.cacheFilters();
    this.toggleModal();
  };
  _proto.handleApplyModal = function handleApplyModal() {
    this.toggleModal();
    this.propagateChange();
  };
  _proto.handleCancelModal = function handleCancelModal() {
    this.restoreFilters();
    this.toggleModal();
  };
  _proto.handleLocationChange = function handleLocationChange(stateCode) {
    var _objectSpread2,
      _this4 = this;
    var selectedFilters = this.state.selectedFilters;
    var newSelectedFilters = {
      selectedFilters: _objectSpread(_objectSpread({}, selectedFilters), {}, (_objectSpread2 = {}, _objectSpread2[_offersV.filtersMap.ZIP_CODE] = stateCode, _objectSpread2))
    };
    this.setState(newSelectedFilters, function () {
      _this4.propagateChange('zipCode');
    });
  };
  _proto.getSelectedFilters = function getSelectedFilters(queryParams) {
    return (0, _offersV2.selectedFiltersFromQuery)(this.filters, _objectSpread({}, queryParams));
  };
  _proto.propagateChange = function propagateChange(filterKey) {
    if (filterKey === void 0) {
      filterKey = 'vehicles';
    }
    var selectedFilters = this.state.selectedFilters;
    var onChange = this.props.onChange;
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'offers-filter',
        eventModel: {
          'filter-device': (0, _commonMediaQuery.getDeviceType)(),
          'filter-zipCode': selectedFilters.zipCode,
          'filter-modelName': (0, _offersFilter.findSelectedValue)(selectedFilters.vehicles)
          // 'filter-modelYear': findSelectedValue(selectedFilters.modelYear),
          // 'filter-offerType': findSelectedValue(selectedFilters.offerTypes),
        }
      });
    }
    onChange(filterKey, selectedFilters, this.filters);
  };
  _proto.cacheFilters = function cacheFilters() {
    var selectedFilters = this.state.selectedFilters;
    this.prevSelectedFilters = _objectSpread({}, selectedFilters);
  };
  _proto.restoreFilters = function restoreFilters() {
    this.setState({
      selectedFilters: this.prevSelectedFilters,
      totalSelectedFilters: (0, _offersFilter.getTotalSelectedFilters)(this.prevSelectedFilters)
    });
  };
  _proto.createChangeHandler = function createChangeHandler(_ref) {
    var _this5 = this;
    var filter = _ref.filter,
      _ref$propagateChange = _ref.propagateChange,
      propagateChange = _ref$propagateChange === void 0 ? false : _ref$propagateChange;
    return function (event) {
      var target = {
        checked: event.target.checked,
        value: event.target.value,
        name: event.target.name
      };
      var stateReducer = function stateReducer(prevState) {
        var newSelectedFilters = (0, _offersFilter.getUpdatedSelectedFiltersState)(filter, target, prevState.selectedFilters, false);
        var newSelectedFiltersErrors = (0, _offersFilter.getUpdatedSelectedFiltersErrorsState)(filter, target.value, prevState.selectedFiltersErrors);
        return {
          selectedFilters: newSelectedFilters,
          selectedFiltersErrors: newSelectedFiltersErrors,
          totalSelectedFilters: (0, _offersFilter.getTotalSelectedFilters)(newSelectedFilters)
        };
      };
      var callback = function callback() {
        if (propagateChange) {
          _this5.propagateChange(filter.key);
        }
      };
      _this5.setState(stateReducer, callback);
    };
  };
  _proto.createSingleDropDownChangeHandler = function createSingleDropDownChangeHandler(_ref2) {
    var _this6 = this;
    var filter = _ref2.filter,
      _ref2$propagateChange = _ref2.propagateChange,
      propagateChange = _ref2$propagateChange === void 0 ? false : _ref2$propagateChange;
    return function (event) {
      event.target.attributes['data-selected'].value = true;
      var target = {
        checked: event.target.attributes['data-selected'].value === 'true',
        value: event.target.innerHTML,
        name: event.target.attributes['data-name'].value
      };
      var stateReducer = function stateReducer(prevState) {
        var newSelectedFilters = (0, _offersFilter.getUpdatedSelectedFiltersState)(filter, target, prevState.selectedFilters, true);
        var newSelectedFiltersErrors = (0, _offersFilter.getUpdatedSelectedFiltersErrorsState)(filter, target.value, prevState.selectedFiltersErrors);
        _this6.locationDropdownRef.current.handleApply();
        return {
          selectedFilters: newSelectedFilters,
          selectedFiltersErrors: newSelectedFiltersErrors,
          totalSelectedFilters: (0, _offersFilter.getTotalSelectedFilters)(newSelectedFilters)
        };
      };
      var callback = function callback() {
        if (propagateChange) {
          _this6.propagateChange(filter.key);
        }
      };
      _this6.setState(stateReducer, callback);
    };
  };
  _proto.createClearHandler = function createClearHandler(_ref3) {
    var _this7 = this;
    var filter = _ref3.filter,
      _ref3$propagateChange = _ref3.propagateChange,
      propagateChange = _ref3$propagateChange === void 0 ? false : _ref3$propagateChange;
    return function () {
      var stateReducer = function stateReducer(prevState) {
        var _objectSpread3, _objectSpread4;
        var _this7$filters$find = _this7.filters.find(function (f) {
            return f.key === filter.key;
          }),
          defaultValue = _this7$filters$find.defaultValue;
        var newSelectedFilters = _objectSpread(_objectSpread({}, prevState.selectedFilters), {}, (_objectSpread3 = {}, _objectSpread3[filter.key] = defaultValue, _objectSpread3));
        var newSelectedFiltersErrors = _objectSpread(_objectSpread({}, prevState.selectedFiltersErrors), {}, (_objectSpread4 = {}, _objectSpread4[filter.key] = null, _objectSpread4));
        return {
          selectedFilters: newSelectedFilters,
          selectedFiltersErrors: newSelectedFiltersErrors,
          totalSelectedFilters: (0, _offersFilter.getTotalSelectedFilters)(newSelectedFilters)
        };
      };
      var callback = function callback() {
        if (propagateChange) {
          _this7.propagateChange(filter.key);
        }
      };
      _this7.setState(stateReducer, callback);
    };
  };
  _proto.toggleModal = function toggleModal() {
    this.setState(function (prevState) {
      return {
        isModalOpen: !prevState.isModalOpen
      };
    });
  };
  _proto.renderFilterInput = function renderFilterInput(filter, device) {
    var theme = this.props.theme;
    var locationInputClass = (0, _clsx4["default"])(device === _commonMediaQuery.SCREENS.MOBILE && _offersFilter2["default"]["LocationFinder__input--mobile"]);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _offersFilter2["default"].LocationFilterContainer
    }, /*#__PURE__*/_react["default"].createElement(_locationFinder["default"], {
      inputClassName: locationInputClass,
      theme: theme,
      label: filter.label,
      onLocationSelect: this.handleLocationChange
    }));
  };
  _proto.offersCountByVehicleCode = function offersCountByVehicleCode(vehicleCode) {
    var vehicleOffersCountInfo = this.props.vehicleOffersCountInfo;
    var match = vehicleOffersCountInfo == null ? void 0 : vehicleOffersCountInfo.find(function (item) {
      return item.vehicleCode === vehicleCode;
    });
    return match ? match.count : 0;
  };
  _proto.renderFilterCheckBoxes = function renderFilterCheckBoxes(filter, device, propagateChange) {
    var _ref4,
      _this8 = this;
    var selectedFilters = this.state.selectedFilters;
    var _this$props2 = this.props,
      theme = _this$props2.theme,
      data = _this$props2.data;
    var offersLabel = data.offersLabel;
    var checkboxClassName = (0, _clsx4["default"])(_offersFilter2["default"].checkbox, device === _commonMediaQuery.SCREENS.MOBILE && !(0, _offersFilter.isVehicleFilter)(filter.key) && (_ref4 = {}, _ref4[theme['col-xs-6']] = true, _ref4[theme['col-sm-12']] = true, _ref4), (0, _offersFilter.isVehicleFilter)(filter.key) && _offersFilter2["default"].checkboxVehicles);
    return filter.options.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
        "data-testid": option.name,
        className: checkboxClassName,
        key: option.name,
        id: option.name,
        name: option.name,
        checked: selectedFilters[filter.key][option.name],
        onChange: _this8.createChangeHandler({
          filter: filter,
          propagateChange: propagateChange
        })
      }, (0, _offersFilter.isVehicleFilter)(filter.key) ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _offersFilter2["default"].checkboxVehiclesInner
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: option.imagePath + "?width=165",
        alt: option.imageAltText
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
        className: theme.mmcMedium
      }, option.label), /*#__PURE__*/_react["default"].createElement("span", {
        className: theme.colorDarkGrey
      }, _this8.offersCountByVehicleCode(option == null ? void 0 : option.code), " ", offersLabel))) : /*#__PURE__*/_react["default"].createElement("p", {
        className: theme.mmcMedium
      }, option.label));
    });
  };
  _proto.renderFilterDropdownOptions = function renderFilterDropdownOptions(filter, device, propagateChange) {
    var _this9 = this;
    var selectedFilters = this.state.selectedFilters;
    var _this$props3 = this.props,
      theme = _this$props3.theme,
      data = _this$props3.data;
    var offersLabel = data.offersLabel;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
      className: _offersFilter2["default"].singleSelectDropdown
    }, " ", filter.options.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        "data-testid": option.label,
        key: option.label,
        "data-key": option.label,
        id: option.label
        // name={option.name}
        // checked={selectedFilters[filter.key][option.name]}
        ,
        "data-name": option.name,
        "data-selected": option.name ? selectedFilters[filter.key][option.name] : false,
        onClick: _this9.createSingleDropDownChangeHandler({
          filter: filter,
          propagateChange: propagateChange
        })
      }, option.label);
    })));
  };
  _proto.renderFilterDropdown = function renderFilterDropdown(filter) {
    var _clsx, _clsx2;
    var selectedFilters = this.state.selectedFilters;
    var _this$props4 = this.props,
      theme = _this$props4.theme,
      data = _this$props4.data;
    var isVehicle = filter.key === _offersV.filtersMap.VEHICLE;
    var actionsClassName = isVehicle ? _offersFilter2["default"].dropdownVehicleActions : _offersFilter2["default"].dropdownActions;

    // const width = isVehicle ? 320 : 200;

    return /*#__PURE__*/_react["default"].createElement(_dropdown["default"], {
      id: (0, _kebabCase["default"])(filter.label),
      label: filter.label,
      actionsClassName: actionsClassName
      // width={width}
      ,
      theme: theme,
      onOpen: this.cacheFilters,
      placeholder: filter.getPlaceholder(selectedFilters)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme.row, _offersFilter2["default"].filterTypeContent)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_offersFilter2["default"].btnPill, (_clsx = {}, _clsx[_offersFilter2["default"].hidden] = !(0, _offersFilter.hasClearBtn)(selectedFilters[filter.key]), _clsx))
    }, /*#__PURE__*/_react["default"].createElement(_buttonPill["default"], {
      label: data.clearButtonLabel,
      "data-testid": filter.key + "-clear-btn",
      className: (0, _clsx4["default"])(_offersFilter2["default"].btnPill, (_clsx2 = {}, _clsx2[_offersFilter2["default"].hidden] = !(0, _offersFilter.hasClearBtn)(selectedFilters[filter.key]), _clsx2)),
      theme: theme,
      onClick: this.createClearHandler({
        filter: filter,
        propagateChange: true
      })
    })), this.renderFilterCheckBoxes(filter, _commonMediaQuery.SCREENS.MOBILE, true)));
  };
  _proto.renderSingleDropdown = function renderSingleDropdown(filter) {
    var selectedFilters = this.state.selectedFilters;
    var _this$props5 = this.props,
      theme = _this$props5.theme,
      data = _this$props5.data;
    var placeholder;
    if (filter.getPlaceholder(selectedFilters)) {
      //if there is no selection
      placeholder = filter.getPlaceholder(selectedFilters);
    } else {
      var placeholderLabelItem = filter.options.filter(function (item) {
        return item.value === "";
      });
      placeholder = placeholderLabelItem && placeholderLabelItem.length > 0 ? placeholderLabelItem[0].label : "";
    }
    return /*#__PURE__*/_react["default"].createElement(_dropdown["default"], {
      id: (0, _kebabCase["default"])(filter.label),
      label: filter.label,
      actionsClassName: _offersFilter2["default"].dropdownActions
      // width={320}
      ,
      theme: theme,
      onOpen: this.cacheFilters,
      placeholder: placeholder,
      ref: this.locationDropdownRef
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme.row)
    }, this.renderFilterDropdownOptions(filter, _commonMediaQuery.SCREENS.MOBILE, true)));
  };
  _proto.renderMobileFilters = function renderMobileFilters() {
    var _this0 = this;
    var _this$props6 = this.props,
      theme = _this$props6.theme,
      data = _this$props6.data,
      market = _this$props6.market;
    var _this$state2 = this.state,
      isModalOpen = _this$state2.isModalOpen,
      totalSelectedFilters = _this$state2.totalSelectedFilters,
      selectedFilters = _this$state2.selectedFilters,
      selectedFiltersErrors = _this$state2.selectedFiltersErrors;
    var filterContentClasses = (0, _clsx4["default"])(theme.row, _offersFilter2["default"].filterTypeContent, _offersFilter2["default"]['filterTypeContent--ca']);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
      "aria-hidden": isModalOpen,
      "data-testid": "toggle-modal",
      className: _offersFilter2["default"].toggleMobile,
      type: "button",
      onClick: this.handleOpenModal
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _clsx4["default"])(theme.mmcIconFilter, _offersFilter2["default"].filterIcon)
    }), /*#__PURE__*/_react["default"].createElement("p", null, data.offerFilterSelectionMobileLabel, ' ', totalSelectedFilters && "(" + totalSelectedFilters + ")")), /*#__PURE__*/_react["default"].createElement(_modal["default"], {
      "data-testid": "modal",
      isOpen: isModalOpen,
      title: data.offerFilterSelectionMobileLabel,
      theme: theme,
      actions: /*#__PURE__*/_react["default"].createElement("div", {
        className: _offersFilter2["default"].modalActionsContainer
      }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        disabled: (0, _offersFilter.hasErrors)(selectedFiltersErrors),
        theme: theme,
        spanClasses: [_offersFilter2["default"].modalActions, _offersFilter2["default"].modalActionApply],
        data: {
          priority: 'critical',
          label: data.applyButtonLabel
        },
        clickEvent: this.handleApplyModal
      }), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        theme: theme,
        spanClasses: [_offersFilter2["default"].modalActions],
        data: {
          priority: 'low',
          label: data.cancelButtonLabel
        },
        clickEvent: this.handleCancelModal
      }))
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.filters.map(function (filter) {
      var _clsx3;
      return filter.type !== _offersV.filtersType.TEXT ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _offersFilter2["default"].filter,
        key: filter.label
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _offersFilter2["default"].filterTypeHeader
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: theme.colorDarkGrey
      }, filter.label), /*#__PURE__*/_react["default"].createElement(_buttonPill["default"], {
        label: data.clearButtonLabel,
        "data-testid": filter.key + "-clear-btn",
        className: (0, _clsx4["default"])(_offersFilter2["default"].btnPill, (_clsx3 = {}, _clsx3[_offersFilter2["default"].hidden] = !(0, _offersFilter.hasClearBtn)(selectedFilters[filter.key]), _clsx3)),
        theme: theme,
        onClick: _this0.createClearHandler({
          filter: filter
        })
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: filterContentClasses
      }, /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
        minWidth: _commonMediaQuery.BREAKPOINTS.xs.MIN,
        maxWidth: _commonMediaQuery.BREAKPOINTS.sm.MAX
      }, _this0.renderFilterCheckBoxes(filter, _commonMediaQuery.SCREENS.MOBILE)))) : market === 'ca' && filter.key === 'zipCode' && /*#__PURE__*/_react["default"].createElement("div", {
        key: filter.label,
        className: _offersFilter2["default"].filter
      }, _this0.renderFilterInput(filter, _commonMediaQuery.SCREENS.MOBILE));
    }))));
  };
  _proto.renderTabletFilters = function renderTabletFilters() {
    var _this1 = this;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.filters.map(function (filter) {
      return filter.type !== _offersV.filtersType.TEXT && /*#__PURE__*/_react["default"].createElement("div", {
        className: _offersFilter2["default"].filter,
        key: filter.label
      }, _this1.renderFilterDropdown(filter));
    }));
  };
  _proto.renderDesktopFilters = function renderDesktopFilters() {
    var _this10 = this;
    var _this$props7 = this.props,
      theme = _this$props7.theme,
      market = _this$props7.market;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme.row, _offersFilter2["default"].filterTypeContent)
    }, this.filters.map(function (filter) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx4["default"])(theme['col-xs-12'], theme['col-sm-6'])
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _offersFilter2["default"].filter,
        key: filter.label
      }, (0, _offersFilter.isVehicleFilter)(filter.key) ? /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx4["default"])(theme.row)
      }, _this10.renderFilterDropdown(filter)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx4["default"])(theme.row)
      }, _this10.renderSingleDropdown(filter)))));
    }));
  };
  _proto.render = function render() {
    var market = this.props.market;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _offersFilter2["default"].offersFilter
    }, this.renderDesktopFilters());
  };
  return OffersFilter;
}(_react["default"].PureComponent);
OffersFilter.displayName = 'OffersFilter';
OffersFilter.defaultProps = {
  onChange: function onChange() {
    return undefined;
  },
  queryParams: {}
};
var _default = exports["default"] = OffersFilter;